import React from 'react';
import { NewsletterDetailQuery } from '../graphql/query/NewsletterDetailQuery';
import { EntityDetailFetcher } from '../components/EntityDetailFetcher';
import typeIntro from '../static/introspection/Newsletter.json';
import { ENTITY } from '../utils/entities';
import { fastTransformer } from 'utils/form';

export const NewsletterDetail: React.FC<{ id: string }> = ({ id }) => (
	<EntityDetailFetcher
		query={NewsletterDetailQuery}
		entityName={ENTITY.NEWSLETTER}
		id={id}
		typeIntro={typeIntro}
		clonable={false}
		fields={[
			'name',
			'target',
			'delivery',
			'inputTemplate',
			'EditorialSection',
			'values',
		]}
		transformer={(data, entity) => {
			data.fields = fastTransformer({
				values: (f) =>
					Object.assign(f, {
						value: JSON.stringify(JSON.parse(f.value), null, 3),
						formatText: true,
					}),
			})(data.fields);
			return data;
		}}
	/>
);
